import { apiV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
import { json, blob, } from '@newtontechnologies/beey-api-js-client/receivers';
export const addSpeaker = async (connection, speakerXml) => connection.fetch()
    .url(apiV2.speakers.url())
    .postJson({ xml: speakerXml })
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchSpeaker = async (connection, speakerId) => connection.fetch()
    .url(apiV2.speakers.id(speakerId).url())
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const updateSpeaker = async (connection, speakerXml) => connection.fetch()
    .url(apiV2.speakers.url())
    .putJson({ xml: speakerXml })
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const deleteSpeaker = async (connection, speakerId) => connection.fetch()
    .url(apiV2.speakers.id(speakerId).url())
    .delete()
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const listSpeakers = async (connection, skip, count, prefix) => connection.fetch()
    .url(apiV2.speakers.url({ skip, count, search: prefix }))
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
const apiRolesListToRoles = (roles) => roles.map((role) => ({ role: role.value, key: role.id }));
export const fetchSpeakerRoleSuggestions = async (connection, prefix, count = 100) => connection.fetch()
    .url(apiV2.speakers.roles.url({ skip: 0, count, search: prefix }))
    .receive(json().map(apiRolesListToRoles))
    .fetch();
export const addSpeakerRole = async (connection, role) => connection.fetch()
    .url(apiV2.speakers.roles.url({ value: role }))
    .postJson({ value: role })
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchSpeakerRoles = async (connection) => connection.fetch()
    .url(apiV2.speakers.roles.url())
    .receive(json().map(apiRolesListToRoles)
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchSpeakerRoleValues = async (connection) => {
    const result = await connection.fetch()
        .url(apiV2.speakers.roles.suggest.url())
        .receive(json().map((response) => response.values)
        .finally(() => 'unexpected'))
        .fetchStrict();
    return result;
};
export const updateSpeakerRole = async (connection, roleId, newRole) => connection.fetch()
    .url(apiV2.speakers.roles.id(roleId).url({ value: newRole }))
    .putJson({ value: newRole })
    .receive(json()
    .catchHttpError((response) => (response.status === 404 ? { error: 'not-found' } : 'unknown'))
    .finally(() => 'unexpected'))
    .fetchStrict();
export const deleteSpeakerRole = async (connection, roleId) => connection.fetch()
    .url(apiV2.speakers.roles.id(roleId).url())
    .delete()
    .receive(json()
    .catchHttpError((response) => (response.status === 403 ? { error: 'forbidden' } : 'unknown'))
    .finally(() => 'unexpected'))
    .fetchStrict();
export const exportSpeakers = async (connection) => connection.fetch()
    .url(apiV2.speakers.export.url())
    .receive(blob())
    .fetch();
export const exportRoles = async (connection) => connection.fetch()
    .url(apiV2.speakers.roles.export.url())
    .receive(blob())
    .fetch();
export const saveVoiceSample = async (connection, projectId, speakerId, sampleStart, sampleLength) => connection.fetch()
    .url(apiV2.speakers.voiceSamples.cutNew.url())
    .postJson({
    ProjectId: projectId,
    SpeakerId: speakerId,
    StartSec: sampleStart,
    LengthSec: sampleLength,
})
    .receive(json()
    .catchHttpError((response) => (response.status === 422 ? { error: 'invalid-id' } : 'unknown'))
    .finally(() => 'unexpected'))
    .fetchStrict();
export const fetchVoiceSamples = async (connection, speakerId) => connection.fetch()
    .url(apiV2.speakers.voiceSamples.url({ speakerId }))
    .receive(json())
    .fetch();
export const fetchVoiceSampleMedia = async (connection, sampleId) => connection.fetch()
    .url(apiV2.speakers.voiceSamples.id(sampleId).data.url())
    .receive(blob())
    .fetch();
export const deleteVoiceSample = async (connection, sampleId) => connection.fetch()
    .url(apiV2.speakers.voiceSamples.id(sampleId).url())
    .delete()
    .receive(json()
    .finally(() => 'unexpected'))
    .fetchStrict();
